import SessionAPI from './Session';
import PlaidAPI from './Plaid';
import UserAPI from './User';
import SurveyAPI from './Survey';
import EventsAPI from './Events';
import Collection from './Collection';
import config from '@/types/config';
import axios from 'axios';
import {
  addAccessTokenHeaders,
  handleError,
  handleNotAuthenticatedError,
  handleSuccess,
  transformResponse,
} from './utils/middlewares';

const baseURL = config.apiUrl + config.apiPrefix;

export const initApi = () => {
  const apiClient = axios.create({
    baseURL,
    timeout: 20000,
    headers: {
      'Content-Type': 'application/json',
    },
    transformResponse: [transformResponse],
  });

  apiClient.interceptors.request.use(addAccessTokenHeaders);

  apiClient.interceptors.response.use(handleSuccess, handleNotAuthenticatedError);

  apiClient.interceptors.response.use(handleSuccess, handleError);

  return {
    apiClient,
    session: new SessionAPI({ apiClient }),
    plaid: new PlaidAPI({ apiClient }),
    user: new UserAPI({ apiClient }),
    survey: new SurveyAPI({ apiClient }),
    events: new EventsAPI({ apiClient }),
    collection: new Collection({ apiClient }),
  };
};

export default initApi();
